import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M227.77-221.925L100.001-349.693l41.769-41.768 85 85 170-170 41.768 42.768L227.77-221.925zm0-304.614L100.001-654.307l41.769-41.768 85 85 170-170 41.768 42.768L227.77-526.539zm292.615 228.845v-59.998h339.998v59.998H520.385zm0-304.614v-59.998h339.998v59.998H520.385z"
      ></path>
    </svg>
  );
}

export default Icon;
